/**UTILIZADO NAS TELAS ONDE USARAM O COMPONENTE*/

import WordServiceRunDialog from "@/views/modules/general/WordServiceRunDialog.vue";
import defaultEmbeddableMixin from "@/mixins/embeddable/resource/defaultEmbeddableMixin";
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
    mixins: [defaultEmbeddableMixin],
    components: {WordServiceRunDialog},
    data() {
        return {
            ui,
            enablePDF: false,
            disabledSubmit: false,
            headerTitle: "",
            fileName: "",
            fields: [],
            job: {
                jobId: "",
                status: "",
                message: ""
            },
            pollTimer: null,
            pollInFlight: false,
            componentAlive: true,

        }
    },
    methods: {

        isFinalStatus(status) {
            return status === "SUCCESS" || status === "ERROR" || status === "TIMEOUT"
        },

        stopJobPolling() {

            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }

            this.pollInFlight = false
        },

        startJobPolling() {

            // evita duplicar
            this.stopJobPolling()

            // primeira consulta imediata (melhor UX)
            this.getWordServiceStatus()

            this.pollTimer = setInterval(() => {
                this.getWordServiceStatus()
            }, 15000)
        },

        async getWordServiceStatus() {

            if (!this.componentAlive) return
            if (!this.job?.jobId) return
            if (this.pollInFlight) return

            this.pollInFlight = true

            try {
                const response = await http.get(
                    "/resource/word/jobs/" + this.job.jobId
                )

                if (!this.componentAlive) return

                this.job = response.data

                if (this.isFinalStatus(this.job.status)) {
                    this.stopJobPolling()
                }

            } catch (error) {
                if (this.componentAlive) {
                    this.responseError(error)
                }
            } finally {
                this.pollInFlight = false
            }
        },


        async sendWordServiceRunDialog() {

            this.disabledSubmit = true
            this.job = {}

            try {
                let data = {...this.form}
                data.fields = this.fields
                data.enablePDF = this.enablePDF

                const response = await http.post(
                    this.path + "/addWordServiceRun/" + this.primaryKey,
                    data
                )

                this.job = response.data

                this.$emit('onSubmit')

                // Inicia polling a cada 15s até SUCCESS/ERROR/TIMEOUT
                this.startJobPolling()
            } catch (error) {
                this.responseError(error)
            } finally {
                this.disabledSubmit = false
            }

        },

        onCloseModal() {
            this.stopJobPolling()
        },

    },

    beforeDestroy() {
        this.componentAlive = false
        this.stopJobPolling()
    },


    props: {
        item: Object,
        path: String,
        primaryKey: Number,
    },

}